export const statusIntegracao = [
    {
        codigo: 0,
        descricao: 'Não integrado',
        variant: 'secondary'
    },
    {
        codigo: 1,
        descricao: 'Aguardando integração',
        variant: 'warning'
    },
    {
        codigo: 2,
        descricao: 'Integrado',
        variant: 'primary'
    },
    {
        codigo: 3,
        descricao: 'Erro',
        variant: 'danger'
    }
]

export function obterStatusIntegracao(status) {
    if (status === null || status === undefined || status === '') {
        return { codigo: null, descricao: '', variant: 'secondary' }
    }

    let encontrado = statusIntegracao.find(item => {
        return item.codigo === Number(status)
    })

    if (!encontrado) {
        encontrado = statusIntegracao.find(item => {
            return (
                item.descricao.toUpperCase() === String(status).toUpperCase()
            )
        })
    }

    return encontrado
        ? encontrado
        : { codigo: null, descricao: String(status), variant: 'secondary' }
}

export const STATUS_NAO_INTEGRADO = 0

export function estaTravado(status) {
    return (
        status !== null &&
        status !== undefined &&
        Number(status) !== STATUS_NAO_INTEGRADO
    )
}

export function motivoBloqueio(status) {
    if (!estaTravado(status)) {
        return null
    }
    switch (Number(status)) {
        case 1:
            return 'Aguardando integração'
        case 2:
            return 'Já integrado'
        case 3:
            return 'Erro na integração anterior'
        default:
            return 'Indisponível para seleção'
    }
}
